import React from 'react';
import moment from 'moment';
import isNode from '../../../modules/ajio-util/isNode.js';

class FormattedDate extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {
      orderCreatedDate = {},
      orderCreatedTime = '',
      dayMonthFormat = false,
      isPDPhase2Enabled = false,
      isRushEnabled = false,
      deliverySLA = ''
    } = this.props;
    const orderCreationTime = orderCreatedTime || moment(orderCreatedDate).format('hh:mmA');

    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    const dateSubscript = [
      'st',
      'nd',
      'rd',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'st',
      'nd',
      'rd',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'th',
      'st'
    ];
    let formattedDate = '';
    let formattedDayMonth = '';
    if (orderCreatedDate === '') return null;
    if (!isNode() && document) {
      if (document.documentMode) {
        orderCreatedDate = orderCreatedDate.split('-').join('/');
      } else {
        orderCreatedDate = orderCreatedDate.split('T')[0] || orderCreatedDate;
      }
    }

    let dateOfOrder = new Date(orderCreatedDate);
    let startDate = dateOfOrder.getDate();
    let displayStartDate = dateSubscript[startDate - 1] || '';
    formattedDate = `${startDate}${displayStartDate} ${
      monthNames[dateOfOrder.getMonth()]
    } ${dateOfOrder.getFullYear()}`;
    formattedDayMonth = `${startDate} ${
      monthNames[dateOfOrder.getMonth()] ? monthNames[dateOfOrder.getMonth()].substring(0, 3) : ''
    }`;
    if (
      (isRushEnabled || isPDPhase2Enabled) &&
      (deliverySLA.includes('HR') || deliverySLA.includes('MIN'))
    ) {
      formattedDate += `, ${orderCreationTime}`;
      formattedDayMonth += `, ${orderCreationTime}`;
    }
    return <span>{dayMonthFormat ? formattedDayMonth : formattedDate}</span>;
  }
}

export default FormattedDate;
